module.exports = __webpack_public_path__ + "static/img/cjx07.5d01a00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cjx07.png
// module id = 164
// module chunks = 0